import React from "react";
import SearchIcon from "@mui/icons-material/Search";
import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AutocompleteStores from "../../NavBar/AutocompleteStores";

const SearchStores = ({ 
  searchValue, 
  setSearchValue, 
  customColor,
  dataStores,
  loadingStores,
  debounceRef,
  fetchDataStores,
  hasSearchIcon,
}) => {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <React.Fragment>
      <SearchIcon onClick={handleClickOpen} sx={{ color: customColor || "white", cursor: "pointer" }} />

      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle
          sx={{
            m: 0,
            p: 2,
            display: "flex",
            justifyContent: "space-between",
            fontSize: "20px",
            alignItems: "center",
          }}
          id="customized-dialog-title"
        >
          <SearchIcon sx={{ color: "black", mr: 1 }} />
          Digite a sua Loja aqui
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{ color: (theme) => theme.palette.grey[500] }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers sx={{ p: 2 }}>
          <AutocompleteStores
            dataStores={dataStores}
            loadingStores={loadingStores}
            debounceRef={debounceRef}
            fetchDataStores={fetchDataStores}
            hasSearchIcon={true}
            textColor="black"
            // sx={{
            //   // Se o fundo do seu modal for branco, ajustamos o contraste aqui:
            //   backgroundColor: '#1a202c', 
            //   borderRadius: '8px',
            // }}
          />
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};

export default SearchStores;